import { render } from "./SimpleHeaderToolbar.vue?vue&type=template&id=76c12a85&scoped=true"
import script from "./SimpleHeaderToolbar.vue?vue&type=script&lang=js"
export * from "./SimpleHeaderToolbar.vue?vue&type=script&lang=js"

import "./SimpleHeaderToolbar.vue?vue&type=style&index=0&id=76c12a85&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76c12a85"

export default script